import { render } from "./cargo-v2-dispute.vue?vue&type=template&id=1ed62d36&scoped=true&ts=true"
import script from "./cargo-v2-dispute.vue?vue&type=script&lang=ts"
export * from "./cargo-v2-dispute.vue?vue&type=script&lang=ts"

import "./cargo-v2-dispute.vue?vue&type=style&index=0&id=1ed62d36&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ed62d36"]])

export default __exports__